export default __webpack_public_path__ + "static/media/Necklace of the Primal Spirit.43959191.jpg";